import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useSearchParams } from "react-router-dom";

const ERROR_MESSAGES: Record<string, string> = {
    access_denied: "You chose not to grant access. You can close this window.",
    invalid_request: "The authorization request was invalid. Please try again.",
    invalid_client:
        "The application is not recognized. Please contact support.",
    unsupported_response_type: "Unsupported response type.",
    invalid_scope: "The requested permissions are not supported.",
    server_error: "A server error occurred. Please try again later.",
};

export default function OAuthErrorPage() {
    const [params] = useSearchParams();
    const error = params.get("error") ?? "server_error";
    const description = params.get("error_description");

    const message =
        description || ERROR_MESSAGES[error] || "An unexpected error occurred.";

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#f5f5f5",
                p: 2,
            }}
        >
            <Box
                sx={{
                    bgcolor: "#fff",
                    borderRadius: 3,
                    p: { xs: 3, sm: 4 },
                    maxWidth: 440,
                    width: "100%",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
                    textAlign: "center",
                }}
            >
                <ErrorOutlineIcon
                    sx={{ fontSize: 52, color: "#e53935", mb: 2 }}
                />
                <Typography
                    sx={{
                        fontSize: "20px",
                        fontWeight: 700,
                        mb: 1,
                        color: "#1a1a1a",
                    }}
                >
                    Authorization Failed
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#555", mb: 3 }}>
                    {message}
                </Typography>
                <Button
                    onClick={() => window.close()}
                    sx={{
                        bgcolor: "#1a1a1a",
                        color: "#fff",
                        borderRadius: "20px",
                        textTransform: "none",
                        px: 4,
                        "&:hover": { bgcolor: "#333" },
                    }}
                >
                    Close Window
                </Button>
            </Box>
        </Box>
    );
}
